import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})

export class TemplateService {
    private accountingUrl = environment.accountingUrl;

    constructor(private http: HttpClient, private cookieService: CookieService) {}

    getTemplates(): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/vendor-form-templates/`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getVendorPoTemplates(): Observable<any> {
      const url = `${this.accountingUrl}/api/v1/vendor-po-form-templates/`;
      return this.http.get<any>(url, { withCredentials: true });
    }

    getBillPaymentTemplates(): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/vendor-payment-form-templates/`;
        return this.http.get<any>(url, { withCredentials: true });
    }
    getBillPaymentTemplateById(templateId: string): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/vendor-payment-form-templates/${templateId}/`;
        return this.http.get<any>(url, { withCredentials: true });
    }
    getBillPaymentDefaultTemplate() : Observable<any> {
        const url = `${this.accountingUrl}/api/v1/vendor-payment-form-templates/default/`;
        return this.http.get<any>(url, { withCredentials: true });
    } 
    getClientSoDefaultTemplate() : Observable<any> {
        const url = `${this.accountingUrl}/api/v1/client-order-form-templates/default`;
        // set cookies
        return this.http.get<any>(url, { withCredentials: true });
    }

    getSOFormTemplates(): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/client-order-form-templates/`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getSOFormTemplateById(templateId: string | number): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/client-order-form-templates/${templateId}`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getEmployeeTemplates(): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/employee-form-templates/`;
        return this.http.get<any>(url, { withCredentials: true });
    }
}